import React from 'react'
import SubHeader from '../general/SubHeader'
import CountUp from 'react-countup';
import AboutImg from '../assets/about-img.jpg';
import WhyChoose from '../general/WhyChoose';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';


const About = () => {
    return (
        <>
            <SubHeader message='About Us' />

            {/* about section */}
            <section className='my-5'>
                <div className='container'>

                    <div className='row'>

                        <div className='col-lg-6 col-md-9 col-12 my-2 about-left'>
                            <div className='about-left-area'>
                                <p className='my-0 fs-4 text-blue fw-bold'><CountUp end={90} duration={4} enableScrollSpy={true} />%</p>
                                <p className='fw-semibold'>Happy Active Clients</p></div>
                            <img src={AboutImg} className='img-fluid rounded-4' alt='about left' />
                        </div>

                        <div className='col-lg-6 col-12 my-lg-2 mt-4'>
                            <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> About Us</p>
                            <p className='sec-heading'>Most Trusted Services since 2017</p>
                            <p className='text-muted fw-semibold'>We are the global software development company in George Town Prayagraj, Uttar Pradesh dedicated to delivering top-notch custom software & Web development services in Prayagraj with speed and excellence. Our team is committed to providing innovative solutions that meet our clients' needs and exceed their expectations.</p>

                            <div className='d-md-flex my-4'>
                                <div className='d-flex mb-2'><i class="fa-regular fa-circle-check py-2 pe-2 text-blue"></i>
                                    <p className='fs-5 fw-bold my-0'>Industry Experience<br />
                                        <span className='fs-6 fw-semibold text-muted'>Leading with 8+ years of Experience in Industry</span></p></div>
                                <div className='d-flex mb-2'><i class="fa-regular fa-circle-check py-2 pe-2 text-blue"></i>
                                    <p className='fs-5 fw-bold my-0'>Active Team<br />
                                        <span className='fs-6 fw-semibold text-muted'>Thanks to our Team who made projects deliver on time</span></p></div>
                            </div>
                            {/* flex ends */}
                            <hr />

                            <p className='text-muted fw-semibold'>We follow a formal software development process based on the SDLC cycle (Software Development Life Cycle). This structured approach ensures that each phase, from planning to maintenance, is properly executed, resulting in high-quality custom software/ website solutions in Prayagraj that meet every client needs and deliver long-term value.</p>

                        </div>

                    </div>
                    {/* row ends */}

                </div>
            </section>
            {/* about section ends */}


            {/* Testimonial section */}
            <section className='py-5 bg-dark text-white'>
                <div className='container text-center'>

                    <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Customer Feedback</p>
                    <p className='sec-heading'>What Our Cients Say?</p>

                    <Swiper
                        spaceBetween={40}
                        slidesPerView={3}
                        onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => console.log(swiper)}
                        modules={[Autoplay]}
                        loop={true}
                        autoplay={{
                            delay: 3000
                        }}
                        breakpoints={{
                            0: {
                              slidesPerView: 1,
                            },
                            768: {
                              slidesPerView: 2,
                            },
                            992: {
                              slidesPerView: 3,
                            }
                          }}
                        className='mt-5'
                    >

                        <SwiperSlide>
                            <div className='review-area'>
                                <div className='text-end'>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i></div>
                                <p className='my-4'>They help us develop a custom software solution. They were quick to understand our needs and delivered an innovative, scalable product within the agreed timeline. Their attention to detail and commitment to delivering a high-quality product made all the difference.</p>
                                <h6>Govind</h6>
                                <p className='fst-italic text-muted'>- Our Client</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className='review-area'>
                                <div className='text-end'>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i></div>
                                <p className='my-4'>From design to functionality, every aspect was executed flawlessly. The website is now faster, more user-friendly, and visually appealing. Highly recommend Dectwin for anyone seeking top-notch web development services. I highly recommend Dectwin for any tech project.</p>
                                <h6>Ruchi</h6>
                                <p className='fst-italic text-muted'>- Our Client</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className='review-area'>
                                <div className='text-end'>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i>
                                <i className='fa-solid text-purple px-1 fa-star'></i></div>
                                <p className='my-4'>The team at Dectwin Services is truly exceptional. They developed a mobile app for our company that exceeded our expectations in both design and functionality. Their expertise in software development and attention to user experience is evident in the final product.</p>
                                <h6>Vedprakash</h6>
                                <p className='fst-italic text-muted'>- Our Client</p>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className='review-area'>
                                <div className='text-end'>
                            <i className='fa-solid text-purple px-1 fa-star'></i>
                            <i className='fa-solid text-purple px-1 fa-star'></i>
                            <i className='fa-solid text-purple px-1 fa-star'></i>
                            <i className='fa-solid text-purple px-1 fa-star'></i>
                            <i className='fa-solid text-purple px-1 fa-star'></i></div>
                            <p className='my-4'>Working with Dectwin Services on our e-commerce platform was a game-changer. They took the time to understand our business model and implemented features that enhanced customer experience and boosted our sales. Communication was seamless, and they kept us updated every step of the way.</p>
                            <h6>Rajkumar</h6>
                            <p className='fst-italic text-muted'>- Our Client</p>
                        </div>
                        </SwiperSlide>

                    </Swiper>

                </div>
            </section>
            {/* Testimonial section ends */}

            <WhyChoose />

        </>
    )
}

export default About
